import DocumentsResultatsAnalyses from '@/view/Documents/DocumentsResultatsAnalyses'
import DocumentsConsultations from '@/view/Documents/DocumentsConsultations'
import DocumentsConsultationGynecologie from '@/view/Documents/DocumentsConsultationGynecologie'
import DocumentsCourrier from '@/view/Documents/DocumentsCourrier'

const TABLE_BREADCRUMB = {
  code: 'document.list.title',
  link: {
    name: 'document/liste',
  },
}

export default [
  {
    path: '/document/resultatsAnalyses',
    name: 'document/resultatsAnalyses',
    component: DocumentsResultatsAnalyses,
    meta: {
      auth: 'hasRole(ROLE_ADMIN,ROLE_PARTICIPANT)',
      breadcrumb: () => [TABLE_BREADCRUMB],
    },
    props: true,
  },

  {
    path: '/document/consultations',
    name: 'document/consultations',
    component: DocumentsConsultations,
    meta: {
      auth: 'hasRole(ROLE_ADMIN,ROLE_PARTICIPANT)',
      breadcrumb: () => [TABLE_BREADCRUMB],
    },
    props: true,
  },

  {
    path: '/document/consultationGynecologique',
    name: 'document/consultationGynecologique',
    component: DocumentsConsultationGynecologie,
    meta: {
      auth: 'hasRole(ROLE_ADMIN,ROLE_PARTICIPANT)',
      breadcrumb: () => [TABLE_BREADCRUMB],
    },
    props: true,
  },

  {
    path: '/document/courrier',
    name: 'document/courrier',
    component: DocumentsCourrier,
    meta: {
      auth: 'hasRole(ROLE_ADMIN,ROLE_PARTICIPANT)',
      breadcrumb: () => [TABLE_BREADCRUMB],
    },
    props: true,
  },
]
